import z from "zod";
import { NpcReputation } from "../entity/types.js";
export const NpcDescriptionOutputSchema = z.object({
    description: z.string().min(1),
});
const NPC_REPUTATION_VALUES_FOR_PLAYER_FACING = Object.values(NpcReputation);
export const NpcPlayerFacingOutputSchema = z.object({
    description: z.string().min(1),
    reputation: z.enum(NPC_REPUTATION_VALUES_FOR_PLAYER_FACING),
});
export const NpcEncounterIntroOutputSchema = z.object({
    reasoning: z.string().optional(),
    text: z.string().min(1),
    options: z.array(z.string().min(1)).length(3),
});
export const NpcEncounterAnchorsOutputSchema = z.object({
    reasoning: z.string().min(1),
    anchors: z.array(z.string().min(1)).length(3),
});
export const NpcEncounterAidOutputSchema = z.object({
    text: z.string().min(1),
    accept_response: z.string().min(1),
    accept_text: z.string().min(1),
    decline_response: z.string().min(1),
    decline_text: z.string().min(1),
});
// Narrative for an exchange node (the deal — which items move each way — is decided
// by a separate call with a dynamic schema). decline_text is unused when the refusal
// routes to combat, but is always supplied to keep the shape uniform.
export const NpcEncounterExchangeTextOutputSchema = z.object({
    text: z.string().min(1),
    accept_response: z.string().min(1),
    accept_text: z.string().min(1),
    decline_response: z.string().min(1),
    decline_text: z.string().min(1),
});
export const NpcEncounterQuestOutputSchema = z.object({
    text: z.string().min(1),
    accept_response: z.string().min(1),
    accept_text: z.string().min(1),
    decline_response: z.string().min(1),
    decline_text: z.string().min(1),
});
export const NpcEncounterMemoryOutputSchema = z.object({
    memory: z.string().nullable().describe('A 1-2 sentence summary of what happened in this encounter, written from the NPC\'s perspective. Null if nothing worth remembering occurred.'),
});
const NPC_REPUTATION_VALUES = Object.values(NpcReputation);
export const NpcStartingReputationOutputSchema = z.object({
    reputation: z.enum(NPC_REPUTATION_VALUES).describe('The NPC\'s initial disposition toward the player.'),
});
export const NpcEncounterJoinQuestOutputSchema = z.object({
    offer_text: z.string().min(1),
    accept_response: z.string().min(1),
    accept_text: z.string().min(1),
    decline_response: z.string().min(1),
    decline_text: z.string().min(1),
});
export const NpcEncounterJoinOutputSchema = z.object({
    willing: z.boolean(),
    cost: z.number().int().min(0),
    offer_text: z.string().min(1),
    accept_text: z.string().min(1),
    decline_text: z.string().min(1),
    refusal_text: z.string().min(1),
});
